import { useCallback, useRef } from 'react'

export const useMessageHeight = (
  updateHeight: (height: number | null) => void
) => {
  const messageRef = useRef<HTMLDivElement | null>(null)
  const observerRef = useRef<ResizeObserver | null>(null)

  const setRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        messageRef.current = node
        if (observerRef.current) observerRef.current.disconnect()
        observerRef.current = new ResizeObserver(() => {
          updateHeight(node.offsetHeight)
        })
        observerRef.current.observe(node)
        updateHeight(node.offsetHeight)
      } else {
        if (observerRef.current) {
          observerRef.current.disconnect()
          observerRef.current = null
        }
        updateHeight(null)
      }
    },
    [updateHeight]
  )

  return setRef
}
